import { requestAuth } from "../components/services/RequestService";
import config from "../config.json";
const hostname = window.location.hostname;

export const validateStatus = (state) => {
  const status = [200, 201, 202, 203, 204, 204];
  if (status && status.indexOf(state) > -1) {
    return true;
  }
  return false;
};
export const validateArray = (list) => {
  return list && Array.isArray(list) && list.length > 0;
};

export const validateUrlToOpen = (url, institutionParam) => {
  if (url?.startsWith("/")) {
    if (hostname === config.hostname) {
      if (institutionParam?.find((i) => i.code === "mediaRequest")?.value) {
        return (
          institutionParam?.find((i) => i.code === "mediaRequest")?.value + url
        );
      }
      return url;
    } else {
      if (institutionParam?.find((i) => i.code === "mediaRequest2")?.value) {
        return (
          institutionParam?.find((i) => i.code === "mediaRequest2")?.value + url
        );
      }
      return url;
    }
  }

  return url;
};

export function parseJsonSafe(jsonString) {
  if (!jsonString || typeof jsonString !== "string") return null;

  try {
    const parsed = JSON.parse(jsonString);
    return parsed;
  } catch (error) {
    return null;
  }
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const daysOfWeek = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${dayOfWeek} ${day}, ${month} de ${year}`;
}

export const formatDatePerType = (date, format) => {
  console.log(format);
  if (format === "input") {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
  } else if (format === "localtime") {
    return date.toLocaleTimeString("es-BO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } else if (format === "datetimeString") {
    const newDate = new Date(date);

    const daysOfWeek = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ];
    const months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    const dayOfWeek = daysOfWeek[newDate.getDay()];
    const day = newDate.getDate();
    const month = months[newDate.getMonth()];
    const year = newDate.getFullYear();
    const hour = newDate.getHours();
    const minute = newDate.getMinutes();

    return `${dayOfWeek}, ${day} de ${month} de ${year} a las ${hour
      .toLocaleString()
      .padStart(2, "0")}:${minute.toLocaleString().padStart(2, "0")}`;
  } else {
    return date.toLocaleDateString("es-BO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
};

export function roundDecimals(num) {
  return num && typeof num === "number" ? Math.round(num * 100) / 100 : 0;
}
export function numberWithDecimals(num) {
  return num || num === 0
    ? roundDecimals(num).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "";
}

export const getItemDetails = (item) => {
  try {
    return JSON.parse(item.details || "{}");
  } catch {
    return {};
  }
};

export const getAccountIdByCode = (accountCode, accounts) => {
  if (!accountCode || !accounts.length) return null;

  const account = accounts.find((acc) => acc.code === accountCode);
  return account ? account.id : null;
};

export const getAccountIdSubByPlanilla = async (planillaNum, accounts) => {
  try {
    if (!planillaNum) return null;

    const response = await requestAuth(
      "get",
      `${config.requestURLConta}/api/Account/subfijo/0?nro=${Number(planillaNum)}`,
    );

    const subfijo = response.data;
    if (!subfijo || !subfijo.cuentaContable) {
      console.warn(`No se encontró cuenta para planilla: ${planillaNum}`);
      return null;
    }

    // Buscar el id de la cuenta usando el código de cuenta contable
    const accountCode = subfijo.cuentaContable;
    return getAccountIdByCode(accountCode, accounts);
  } catch (error) {
    console.error("Error obteniendo subfijo:", error);
    return null;
  }
};
